import Orderable from "./models/Orderable"
import { ObservableFromFetch } from "./ObservableFromFetch"

export const getOrderableTests = (id: number) => ObservableFromFetch<Orderable>(`Results/OrderableTest?id=${id}`)
